import { useAuth } from "../context/AuthContext";
import { useOrganization } from "../context/OrganizationContext";
import { QueueWidget } from "../modules/queue/components/QueueWidget";

export function DashboardPage() {
  const { user, authenticated } = useAuth();
  const { activeOrganization } = useOrganization();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <div>
        <h2 style={{ marginBottom: 8 }}>Dashboard</h2>
        {authenticated && user ? (
          <div style={{ color: "var(--color-text-secondary, #8a919b)" }}>
            Welcome, <strong>{user.name || user.email}</strong>
            {activeOrganization?.name && (
              <> · {activeOrganization.name}</>
            )}
          </div>
        ) : (
          <p>Sign in to access your documents and workflows.</p>
        )}
      </div>

      {authenticated && <QueueWidget />}
    </div>
  );
}
